module.exports = __webpack_public_path__ + "img/infraicon5.bdf919f1.svg";